// Cache-bust helper for gallery images. Placeholders live in /gallery/*.jpg
// (served by the frontend). When admin re-uploads a slot, the backend stores
// the new image in Emergent Object Storage and returns a version; from then on
// we point the src at /api/gallery/{slot}.jpg which proxies from storage.
const GLOBAL_V = "2";

function slotFromSrc(src) {
  const m = /\/gallery\/([^./?]+)\.jpg/.exec(src);
  return m ? m[1] : null;
}

export function bust(src, versionMap) {
  if (!src) return src;
  const slot = slotFromSrc(src);
  const uploaded = versionMap && slot && versionMap[slot];
  if (uploaded) {
    return `/api/gallery/${slot}.jpg?v=${uploaded}`;
  }
  const sep = src.includes("?") ? "&" : "?";
  return `${src}${sep}v=${GLOBAL_V}`;
}
